import ServicesDetail from "../../components/Services/ServicesDetail/ServicesDetail";

const ServicesDetailPage = () => {
  return <ServicesDetail />;
};

export default ServicesDetailPage;
